module.exports = __webpack_public_path__ + "static/media/kitchen.d3e2e2f8.svg";